import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormlyTypeService {
  #triggerCheck = signal(0);

  public setTriggerCheck(value: number): void {
    this.#triggerCheck.set(value);
  }

  public getTriggerCheck(): number {
    return this.#triggerCheck.asReadonly()();
  }
}
